/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseIdentApi } from '../../base-api';
export type FeatureConfigMetadataFragment = { __typename: 'FeatureMetaDataType', featureType: Types.FeatureTypeEnum, deviceTypes?: Array<Types.DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename: 'FileExtensionMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename: 'FileToDeviceTypeMappingType', deviceType: Types.DeviceTypeEnum, fileExtension: string, projectType: Types.ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename: 'FileToFileTypeMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: Types.ProjectTypeEnum }> };

export type FeatureConfigOptionFragment = { __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> };

export type FeatureConfigFragment = { __typename: 'FeatureConfigType', feature: Types.FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename: 'FeatureMetaDataType', featureType: Types.FeatureTypeEnum, deviceTypes?: Array<Types.DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename: 'FileExtensionMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename: 'FileToDeviceTypeMappingType', deviceType: Types.DeviceTypeEnum, fileExtension: string, projectType: Types.ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename: 'FileToFileTypeMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: Types.ProjectTypeEnum }> } };

export type FileTypeFragment = { __typename: 'FileTypeType', extension: string, description: string, projectType: Types.ProjectTypeEnum, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> };

export type DeviceTypeFragment = { __typename: 'DeviceConfigType', deviceType: Types.DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> };

export type IdeFragment = { __typename: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<Types.IdeLanguageEnum>, factoryAgentAvailable: Array<Types.ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename: 'FeatureConfigType', feature: Types.FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename: 'FeatureMetaDataType', featureType: Types.FeatureTypeEnum, deviceTypes?: Array<Types.DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename: 'FileExtensionMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename: 'FileToDeviceTypeMappingType', deviceType: Types.DeviceTypeEnum, fileExtension: string, projectType: Types.ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename: 'FileToFileTypeMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: Types.ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename: 'FileTypeType', extension: string, description: string, projectType: Types.ProjectTypeEnum, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename: 'DeviceConfigType', deviceType: Types.DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }> };

export type FeatureFlagFragment = { __typename: 'FeatureFlagType', featureName: string, description?: string, isEnabled: boolean };

export type LicenseConfigFragment = { __typename: 'LicenseConfigType', inputs: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> };

export type VendorFragment = { __typename: 'VendorResponseType', name: string, vendorId: string, ides?: Array<{ __typename: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<Types.IdeLanguageEnum>, factoryAgentAvailable: Array<Types.ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename: 'FeatureConfigType', feature: Types.FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename: 'FeatureMetaDataType', featureType: Types.FeatureTypeEnum, deviceTypes?: Array<Types.DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename: 'FileExtensionMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename: 'FileToDeviceTypeMappingType', deviceType: Types.DeviceTypeEnum, fileExtension: string, projectType: Types.ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename: 'FileToFileTypeMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: Types.ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename: 'FileTypeType', extension: string, description: string, projectType: Types.ProjectTypeEnum, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename: 'DeviceConfigType', deviceType: Types.DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }> }>, licenseConfig?: { __typename: 'LicenseConfigType', inputs: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> } };

export type IdentUserInfoFragment = { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type OwnerUserInfoFragment = { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string };

export type PolicyFragment = { __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string };

export type UserRoleFragment = { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type OwnUserRoleFragment = { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type BaseUserFragment = { __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean };

export type UserFragment = { __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type BaseTenantFragment = { __typename: 'TenantResponseType', tenantId: string, companyName: string, owner: { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } };

export type TenantFragment = { __typename: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<Types.VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, minProjectVersionCommentLength?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, uiPreferences?: any, tenantId: string, companyName: string, owner: { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } };

export type UserRoleLinkFragment = { __typename: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number };

export type TermsAndConditionsAcceptanceFragment = { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any };

export type CreateUserMutationVariables = Types.Exact<{
  user: Types.CreateUserInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser: { __typename: 'UserResponseType', userId: string } };

export type LinkRoleToUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
  expirationTimestamp?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type LinkRoleToUserMutation = { __typename: 'Mutation', createUserRoleUserLink: { __typename: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type CreateUserRoleMutationVariables = Types.Exact<{
  userRole: Types.CreateUserRoleInput;
}>;


export type CreateUserRoleMutation = { __typename: 'Mutation', createUserRole: { __typename: 'UserRoleResponseType', userRoleId: string } };

export type UpdateUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  user: Types.UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser: { __typename: 'UserResponseType', userId: string } };

export type DeleteRoleMutationVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type DeleteRoleMutation = { __typename: 'Mutation', deleteUserRole: { __typename: 'UserRoleResponseType', userRoleId: string, users: { __typename: 'PaginatedUserResponseType', items: Array<{ __typename: 'UserResponseType', userId: string }> } } };

export type RemoveRoleFromUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
}>;


export type RemoveRoleFromUserMutation = { __typename: 'Mutation', deleteUserRoleUserLink?: any };

export type DeleteUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUser: { __typename: 'UserResponseType', userId: string } };

export type UpdateUserRoleMutationVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
  userRole: Types.UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename: 'Mutation', updateUserRole: { __typename: 'UserRoleResponseType', userRoleId: string } };

export type SelectTenantMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type SelectTenantMutation = { __typename: 'Mutation', selectTenant?: any };

export type UpdateTenantMutationVariables = Types.Exact<{
  tenant: Types.UpdateTenantInput;
}>;


export type UpdateTenantMutation = { __typename: 'Mutation', updateTenant: { __typename: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<Types.VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, minProjectVersionCommentLength?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, uiPreferences?: any, tenantId: string, companyName: string, owner: { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } } };

export type UpdateUserRoleLinkMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  userRoleId: Types.Scalars['String']['input'];
  expirationTimestamp?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateUserRoleLinkMutation = { __typename: 'Mutation', updateUserRoleUserLink: { __typename: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type GenerateTwoFactorAuthTokenMutationVariables = Types.Exact<{
  verificationMethod: Types.Scalars['String']['input'];
}>;


export type GenerateTwoFactorAuthTokenMutation = { __typename: 'Mutation', generateTwoFactorAuthToken: { __typename: 'GenerateTwoFactorAuthTokenResponseType', sessionId: string } };

export type AuthenticateTwoFactorAuthTokenMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  challenge: Types.Scalars['String']['input'];
}>;


export type AuthenticateTwoFactorAuthTokenMutation = { __typename: 'Mutation', authenticateTwoFactorAuthToken: { __typename: 'AuthenticateTwoFactorAuthTokenResponseType', status: string, sessionId?: string, expiresAt?: any } };

export type VerifyTotpTwoFactorAuthMutationVariables = Types.Exact<{
  challenge: Types.Scalars['String']['input'];
}>;


export type VerifyTotpTwoFactorAuthMutation = { __typename: 'Mutation', verifyTotpTwoFactorAuth: { __typename: 'AuthenticateTwoFactorAuthTokenResponseType', status: string, sessionId?: string, expiresAt?: any } };

export type AcceptTermsAndConditionsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type AcceptTermsAndConditionsMutation = { __typename: 'Mutation', acceptTermsAndConditions: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any } };

export type UpdateUserUiPreferencesMutationVariables = Types.Exact<{
  uiPreferences?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  objectVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateUserUiPreferencesMutation = { __typename: 'Mutation', updateUserUiPreferences: { __typename: 'UserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type ReadTenantQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTenantQuery = { __typename: 'Query', readTenant: { __typename: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<Types.VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, minProjectVersionCommentLength?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, uiPreferences?: any, tenantId: string, companyName: string, vendors: Array<{ __typename: 'VendorResponseType', name: string, vendorId: string, ides?: Array<{ __typename: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<Types.IdeLanguageEnum>, factoryAgentAvailable: Array<Types.ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename: 'FeatureConfigType', feature: Types.FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename: 'FeatureMetaDataType', featureType: Types.FeatureTypeEnum, deviceTypes?: Array<Types.DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename: 'FileExtensionMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename: 'FileToDeviceTypeMappingType', deviceType: Types.DeviceTypeEnum, fileExtension: string, projectType: Types.ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename: 'FileToFileTypeMappingType', projectType: Types.ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: Types.ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename: 'FileTypeType', extension: string, description: string, projectType: Types.ProjectTypeEnum, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename: 'DeviceConfigType', deviceType: Types.DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> }> }>, licenseConfig?: { __typename: 'LicenseConfigType', inputs: Array<{ __typename: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: Types.InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename: 'InputOptionType', value: any, label: string }> }> } }>, featureFlags?: Array<{ __typename: 'FeatureFlagType', featureName: string, description?: string, isEnabled: boolean }>, owner: { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } } };

export type ReadAllUsersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.UserFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllUsersQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedUserResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } }> } };

export type ReadAllUsersBaseQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.UserFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllUsersBaseQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedUserResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> } };

export type ReadUsersCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUsersCountQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedUserResponseType', itemCount: number } };

export type ReadAllRolesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.UserRoleFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllRolesQuery = { __typename: 'Query', readAllUserRoles: { __typename: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type ReadUserQuery = { __typename: 'Query', readUser: { __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } } };

export type ReadTermsAndConditionsAcceptanceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTermsAndConditionsAcceptanceQuery = { __typename: 'Query', readTermsAndConditionsAcceptance: { __typename: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any } };

export type ReadUserUiPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUserUiPreferencesQuery = { __typename: 'Query', readUserUiPreferences: { __typename: 'UserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type ReadRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type ReadRoleQuery = { __typename: 'Query', readUserRole: { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadUsersForRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadUsersForRoleQuery = { __typename: 'Query', readUsersForUserRole: { __typename: 'PaginatedUserResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } }> } };

export type ReadTenantsForUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadTenantsForUserQuery = { __typename: 'Query', readAdditionalTenantsForUser: { __typename: 'PaginatedTenantResponseType', items: Array<{ __typename: 'TenantResponseType', tenantId: string, companyName: string, owner: { __typename: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } }> } };

export type ReadUserRoleLinksForUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type ReadUserRoleLinksForUserQuery = { __typename: 'Query', readUserRoleUserLinksForUser: { __typename: 'PaginatedUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadUserRoleLinksForRoleQueryVariables = Types.Exact<{
  userRoleId: Types.Scalars['String']['input'];
}>;


export type ReadUserRoleLinksForRoleQuery = { __typename: 'Query', readUserRoleUserLinksForUserRole: { __typename: 'PaginatedUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadPoliciesForUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type ReadPoliciesForUserQuery = { __typename: 'Query', readUserRolesForUser: { __typename: 'PaginatedUserRoleResponseType', items: Array<{ __typename: 'UserRoleResponseType', policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadPoliciesForOwnUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadPoliciesForOwnUserQuery = { __typename: 'Query', readUserRolesForOwnUser: { __typename: 'PaginatedUserRoleResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadGroupedIdentitiesCountQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadGroupedIdentitiesCountQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedUserResponseType', itemCount: number }, readAllUserRoles: { __typename: 'PaginatedUserRoleResponseType', itemCount: number } };

export type ReadUngroupedIdentitiesCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUngroupedIdentitiesCountQuery = { __typename: 'Query', readAllUsers: { __typename: 'PaginatedUserResponseType', itemCount: number }, readAllUserRoles: { __typename: 'PaginatedUserRoleResponseType', itemCount: number } };

export type ReadGroupedIdentityCountsQueryVariables = Types.Exact<{
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGroupedIdentityCountsQuery = { __typename: 'Query', readGroupedIdentityCounts: Array<{ __typename: 'GroupedIdentityCountResponseType', groupId: string, users: number, userRoles: number }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const FeatureFlagFragmentDoc = new TypedDocumentString(`
    fragment FeatureFlag on FeatureFlagType {
  __typename
  featureName
  description
  isEnabled
}
    `, {"fragmentName":"FeatureFlag"});
export const FeatureConfigOptionFragmentDoc = new TypedDocumentString(`
    fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}
    `, {"fragmentName":"FeatureConfigOption"});
export const FeatureConfigMetadataFragmentDoc = new TypedDocumentString(`
    fragment FeatureConfigMetadata on FeatureMetaDataType {
  __typename
  featureType
  deviceTypes
  projectFileExtensions {
    __typename
    projectType
    fileExtension
  }
  fileExtensionsToDeviceTypes {
    __typename
    deviceType
    fileExtension
    projectType
  }
  fileToFileExtensions {
    __typename
    projectType
    fileExtension
    destinationFileExtension
    destinationProjectType
  }
}
    `, {"fragmentName":"FeatureConfigMetadata"});
export const FeatureConfigFragmentDoc = new TypedDocumentString(`
    fragment FeatureConfig on FeatureConfigType {
  __typename
  feature
  options {
    __typename
    ...FeatureConfigOption
  }
  requiredFeatureFlag
  metaData {
    __typename
    ...FeatureConfigMetadata
  }
}
    fragment FeatureConfigMetadata on FeatureMetaDataType {
  __typename
  featureType
  deviceTypes
  projectFileExtensions {
    __typename
    projectType
    fileExtension
  }
  fileExtensionsToDeviceTypes {
    __typename
    deviceType
    fileExtension
    projectType
  }
  fileToFileExtensions {
    __typename
    projectType
    fileExtension
    destinationFileExtension
    destinationProjectType
  }
}
fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}`, {"fragmentName":"FeatureConfig"});
export const FileTypeFragmentDoc = new TypedDocumentString(`
    fragment FileType on FileTypeType {
  __typename
  extension
  description
  projectType
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
    fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}`, {"fragmentName":"FileType"});
export const DeviceTypeFragmentDoc = new TypedDocumentString(`
    fragment DeviceType on DeviceConfigType {
  __typename
  deviceType
  port
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
    fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}`, {"fragmentName":"DeviceType"});
export const IdeFragmentDoc = new TypedDocumentString(`
    fragment IDE on IdeConfigResponseType {
  __typename
  name
  allowedLicenseVersions
  ideConfigId
  licenseRequired
  multiDeviceSupport
  vendorId
  requiredFeatureFlag
  availableLanguages
  factoryAgentAvailable
  features {
    __typename
    ...FeatureConfig
  }
  fileTypes {
    __typename
    ...FileType
  }
  devices {
    __typename
    ...DeviceType
  }
  additionalInformation
}
    fragment FeatureConfigMetadata on FeatureMetaDataType {
  __typename
  featureType
  deviceTypes
  projectFileExtensions {
    __typename
    projectType
    fileExtension
  }
  fileExtensionsToDeviceTypes {
    __typename
    deviceType
    fileExtension
    projectType
  }
  fileToFileExtensions {
    __typename
    projectType
    fileExtension
    destinationFileExtension
    destinationProjectType
  }
}
fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}
fragment FeatureConfig on FeatureConfigType {
  __typename
  feature
  options {
    __typename
    ...FeatureConfigOption
  }
  requiredFeatureFlag
  metaData {
    __typename
    ...FeatureConfigMetadata
  }
}
fragment FileType on FileTypeType {
  __typename
  extension
  description
  projectType
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment DeviceType on DeviceConfigType {
  __typename
  deviceType
  port
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}`, {"fragmentName":"IDE"});
export const LicenseConfigFragmentDoc = new TypedDocumentString(`
    fragment LicenseConfig on LicenseConfigType {
  __typename
  inputs {
    __typename
    ...FeatureConfigOption
  }
}
    fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}`, {"fragmentName":"LicenseConfig"});
export const VendorFragmentDoc = new TypedDocumentString(`
    fragment Vendor on VendorResponseType {
  __typename
  name
  vendorId
  ides {
    __typename
    ...IDE
  }
  licenseConfig {
    __typename
    ...LicenseConfig
  }
}
    fragment FeatureConfigMetadata on FeatureMetaDataType {
  __typename
  featureType
  deviceTypes
  projectFileExtensions {
    __typename
    projectType
    fileExtension
  }
  fileExtensionsToDeviceTypes {
    __typename
    deviceType
    fileExtension
    projectType
  }
  fileToFileExtensions {
    __typename
    projectType
    fileExtension
    destinationFileExtension
    destinationProjectType
  }
}
fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}
fragment FeatureConfig on FeatureConfigType {
  __typename
  feature
  options {
    __typename
    ...FeatureConfigOption
  }
  requiredFeatureFlag
  metaData {
    __typename
    ...FeatureConfigMetadata
  }
}
fragment FileType on FileTypeType {
  __typename
  extension
  description
  projectType
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment DeviceType on DeviceConfigType {
  __typename
  deviceType
  port
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment IDE on IdeConfigResponseType {
  __typename
  name
  allowedLicenseVersions
  ideConfigId
  licenseRequired
  multiDeviceSupport
  vendorId
  requiredFeatureFlag
  availableLanguages
  factoryAgentAvailable
  features {
    __typename
    ...FeatureConfig
  }
  fileTypes {
    __typename
    ...FileType
  }
  devices {
    __typename
    ...DeviceType
  }
  additionalInformation
}
fragment LicenseConfig on LicenseConfigType {
  __typename
  inputs {
    __typename
    ...FeatureConfigOption
  }
}`, {"fragmentName":"Vendor"});
export const BaseUserFragmentDoc = new TypedDocumentString(`
    fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}
    `, {"fragmentName":"BaseUser"});
export const PolicyFragmentDoc = new TypedDocumentString(`
    fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
    `, {"fragmentName":"Policy"});
export const IdentUserInfoFragmentDoc = new TypedDocumentString(`
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
    `, {"fragmentName":"IdentUserInfo"});
export const UserRoleFragmentDoc = new TypedDocumentString(`
    fragment UserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseUser
    }
  }
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}`, {"fragmentName":"UserRole"});
export const OwnUserRoleFragmentDoc = new TypedDocumentString(`
    fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}`, {"fragmentName":"OwnUserRole"});
export const UserFragmentDoc = new TypedDocumentString(`
    fragment User on UserResponseType {
  __typename
  ...BaseUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnUserRole
    }
    pages
    itemCount
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}`, {"fragmentName":"User"});
export const OwnerUserInfoFragmentDoc = new TypedDocumentString(`
    fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}
    `, {"fragmentName":"OwnerUserInfo"});
export const BaseTenantFragmentDoc = new TypedDocumentString(`
    fragment BaseTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...OwnerUserInfo
  }
}
    fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}`, {"fragmentName":"BaseTenant"});
export const TenantFragmentDoc = new TypedDocumentString(`
    fragment Tenant on TenantResponseType {
  __typename
  ...BaseTenant
  ownerId
  ssoEnabled
  objectVersion
  country
  industry
  enforceMfa
  enforceMfaForIdeaas
  twoFactorAuthMethods
  manageSsoUsersInSda
  maxUserRoleExpirationDays
  minProjectVersionCommentLength
  creationTimestamp
  isActive
  metaData
  uiPreferences
}
    fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}
fragment BaseTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...OwnerUserInfo
  }
}`, {"fragmentName":"Tenant"});
export const UserRoleLinkFragmentDoc = new TypedDocumentString(`
    fragment UserRoleLink on UserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}
    `, {"fragmentName":"UserRoleLink"});
export const TermsAndConditionsAcceptanceFragmentDoc = new TypedDocumentString(`
    fragment TermsAndConditionsAcceptance on TermsAndConditionsAcceptanceResponseType {
  __typename
  accepted
  termsAndConditionsVersion
  latestTermsAndConditionsVersion
  latestTermsAndConditionsVersionAccepted
  acceptedTimestamp
}
    `, {"fragmentName":"TermsAndConditionsAcceptance"});
export const CreateUserDocument = new TypedDocumentString(`
    mutation CreateUser($user: CreateUserInput!) {
  __typename
  createUser(user: $user) {
    __typename
    userId
  }
}
    `);
export const LinkRoleToUserDocument = new TypedDocumentString(`
    mutation LinkRoleToUser($userId: String!, $userRoleId: String!, $expirationTimestamp: DateTime) {
  __typename
  createUserRoleUserLink(
    userId: $userId
    userRoleId: $userRoleId
    input: {expirationTimestamp: $expirationTimestamp}
  ) {
    __typename
    ...UserRoleLink
  }
}
    fragment UserRoleLink on UserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const CreateUserRoleDocument = new TypedDocumentString(`
    mutation CreateUserRole($userRole: CreateUserRoleInput!) {
  __typename
  createUserRole(userRole: $userRole) {
    __typename
    userRoleId
  }
}
    `);
export const UpdateUserDocument = new TypedDocumentString(`
    mutation UpdateUser($userId: String!, $user: UpdateUserInput!) {
  __typename
  updateUser(userId: $userId, user: $user) {
    __typename
    userId
  }
}
    `);
export const DeleteRoleDocument = new TypedDocumentString(`
    mutation DeleteRole($userRoleId: String!) {
  __typename
  deleteUserRole(userRoleId: $userRoleId) {
    __typename
    userRoleId
    users {
      __typename
      items {
        __typename
        userId
      }
    }
  }
}
    `);
export const RemoveRoleFromUserDocument = new TypedDocumentString(`
    mutation RemoveRoleFromUser($userId: String!, $userRoleId: String!) {
  __typename
  deleteUserRoleUserLink(userId: $userId, userRoleId: $userRoleId)
}
    `);
export const DeleteUserDocument = new TypedDocumentString(`
    mutation DeleteUser($userId: String!) {
  __typename
  deleteUser(userId: $userId) {
    __typename
    userId
  }
}
    `);
export const UpdateUserRoleDocument = new TypedDocumentString(`
    mutation UpdateUserRole($userRoleId: String!, $userRole: UpdateUserRoleInput!) {
  __typename
  updateUserRole(userRoleId: $userRoleId, userRole: $userRole) {
    __typename
    userRoleId
  }
}
    `);
export const SelectTenantDocument = new TypedDocumentString(`
    mutation SelectTenant($tenantId: String!) {
  __typename
  selectTenant(tenantId: $tenantId)
}
    `);
export const UpdateTenantDocument = new TypedDocumentString(`
    mutation UpdateTenant($tenant: UpdateTenantInput!) {
  __typename
  updateTenant(tenant: $tenant) {
    __typename
    ...Tenant
  }
}
    fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}
fragment BaseTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...OwnerUserInfo
  }
}
fragment Tenant on TenantResponseType {
  __typename
  ...BaseTenant
  ownerId
  ssoEnabled
  objectVersion
  country
  industry
  enforceMfa
  enforceMfaForIdeaas
  twoFactorAuthMethods
  manageSsoUsersInSda
  maxUserRoleExpirationDays
  minProjectVersionCommentLength
  creationTimestamp
  isActive
  metaData
  uiPreferences
}`);
export const UpdateUserRoleLinkDocument = new TypedDocumentString(`
    mutation UpdateUserRoleLink($userId: String!, $userRoleId: String!, $expirationTimestamp: DateTime, $objectVersion: Int) {
  __typename
  updateUserRoleUserLink(
    userId: $userId
    userRoleId: $userRoleId
    input: {expirationTimestamp: $expirationTimestamp, objectVersion: $objectVersion}
  ) {
    __typename
    ...UserRoleLink
  }
}
    fragment UserRoleLink on UserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const GenerateTwoFactorAuthTokenDocument = new TypedDocumentString(`
    mutation GenerateTwoFactorAuthToken($verificationMethod: String!) {
  __typename
  generateTwoFactorAuthToken(input: {verificationMethod: $verificationMethod}) {
    __typename
    sessionId
  }
}
    `);
export const AuthenticateTwoFactorAuthTokenDocument = new TypedDocumentString(`
    mutation AuthenticateTwoFactorAuthToken($sessionId: String!, $challenge: String!) {
  __typename
  authenticateTwoFactorAuthToken(
    input: {sessionId: $sessionId, challenge: $challenge}
  ) {
    __typename
    status
    sessionId
    expiresAt
  }
}
    `);
export const VerifyTotpTwoFactorAuthDocument = new TypedDocumentString(`
    mutation VerifyTotpTwoFactorAuth($challenge: String!) {
  __typename
  verifyTotpTwoFactorAuth(input: {challenge: $challenge}) {
    __typename
    status
    sessionId
    expiresAt
  }
}
    `);
export const AcceptTermsAndConditionsDocument = new TypedDocumentString(`
    mutation AcceptTermsAndConditions {
  __typename
  acceptTermsAndConditions {
    __typename
    ...TermsAndConditionsAcceptance
  }
}
    fragment TermsAndConditionsAcceptance on TermsAndConditionsAcceptanceResponseType {
  __typename
  accepted
  termsAndConditionsVersion
  latestTermsAndConditionsVersion
  latestTermsAndConditionsVersionAccepted
  acceptedTimestamp
}`);
export const UpdateUserUiPreferencesDocument = new TypedDocumentString(`
    mutation UpdateUserUiPreferences($uiPreferences: JSON, $objectVersion: Int) {
  __typename
  updateUserUiPreferences(
    uiPreferences: $uiPreferences
    objectVersion: $objectVersion
  ) {
    __typename
    uiPreferences
    objectVersion
  }
}
    `);
export const ReadTenantDocument = new TypedDocumentString(`
    query ReadTenant {
  __typename
  readTenant {
    __typename
    ...Tenant
    vendors {
      __typename
      ...Vendor
    }
    featureFlags {
      __typename
      ...FeatureFlag
    }
  }
}
    fragment FeatureConfigMetadata on FeatureMetaDataType {
  __typename
  featureType
  deviceTypes
  projectFileExtensions {
    __typename
    projectType
    fileExtension
  }
  fileExtensionsToDeviceTypes {
    __typename
    deviceType
    fileExtension
    projectType
  }
  fileToFileExtensions {
    __typename
    projectType
    fileExtension
    destinationFileExtension
    destinationProjectType
  }
}
fragment FeatureConfigOption on FeatureConfigOptionType {
  __typename
  description
  label
  value
  inputOptions {
    __typename
    value
    label
  }
  required
  validationRegex
  inputType
  defaultValue
}
fragment FeatureConfig on FeatureConfigType {
  __typename
  feature
  options {
    __typename
    ...FeatureConfigOption
  }
  requiredFeatureFlag
  metaData {
    __typename
    ...FeatureConfigMetadata
  }
}
fragment FileType on FileTypeType {
  __typename
  extension
  description
  projectType
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment DeviceType on DeviceConfigType {
  __typename
  deviceType
  port
  additionalInputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment IDE on IdeConfigResponseType {
  __typename
  name
  allowedLicenseVersions
  ideConfigId
  licenseRequired
  multiDeviceSupport
  vendorId
  requiredFeatureFlag
  availableLanguages
  factoryAgentAvailable
  features {
    __typename
    ...FeatureConfig
  }
  fileTypes {
    __typename
    ...FileType
  }
  devices {
    __typename
    ...DeviceType
  }
  additionalInformation
}
fragment FeatureFlag on FeatureFlagType {
  __typename
  featureName
  description
  isEnabled
}
fragment LicenseConfig on LicenseConfigType {
  __typename
  inputs {
    __typename
    ...FeatureConfigOption
  }
}
fragment Vendor on VendorResponseType {
  __typename
  name
  vendorId
  ides {
    __typename
    ...IDE
  }
  licenseConfig {
    __typename
    ...LicenseConfig
  }
}
fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}
fragment BaseTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...OwnerUserInfo
  }
}
fragment Tenant on TenantResponseType {
  __typename
  ...BaseTenant
  ownerId
  ssoEnabled
  objectVersion
  country
  industry
  enforceMfa
  enforceMfaForIdeaas
  twoFactorAuthMethods
  manageSsoUsersInSda
  maxUserRoleExpirationDays
  minProjectVersionCommentLength
  creationTimestamp
  isActive
  metaData
  uiPreferences
}`);
export const ReadAllUsersDocument = new TypedDocumentString(`
    query ReadAllUsers($filter: UserFilterInput, $pagination: PaginationInput) {
  __typename
  readAllUsers(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...User
    }
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}
fragment User on UserResponseType {
  __typename
  ...BaseUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnUserRole
    }
    pages
    itemCount
  }
}`);
export const ReadAllUsersBaseDocument = new TypedDocumentString(`
    query ReadAllUsersBase($filter: UserFilterInput, $pagination: PaginationInput) {
  __typename
  readAllUsers(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...BaseUser
    }
  }
}
    fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}`);
export const ReadUsersCountDocument = new TypedDocumentString(`
    query ReadUsersCount {
  __typename
  readAllUsers {
    __typename
    itemCount
  }
}
    `);
export const ReadAllRolesDocument = new TypedDocumentString(`
    query ReadAllRoles($filter: UserRoleFilterInput, $pagination: PaginationInput) {
  __typename
  readAllUserRoles(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...UserRole
    }
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment UserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseUser
    }
  }
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}`);
export const ReadUserDocument = new TypedDocumentString(`
    query ReadUser($userId: String!) {
  __typename
  readUser(userId: $userId) {
    __typename
    ...User
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}
fragment User on UserResponseType {
  __typename
  ...BaseUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnUserRole
    }
    pages
    itemCount
  }
}`);
export const ReadTermsAndConditionsAcceptanceDocument = new TypedDocumentString(`
    query ReadTermsAndConditionsAcceptance {
  __typename
  readTermsAndConditionsAcceptance {
    __typename
    ...TermsAndConditionsAcceptance
  }
}
    fragment TermsAndConditionsAcceptance on TermsAndConditionsAcceptanceResponseType {
  __typename
  accepted
  termsAndConditionsVersion
  latestTermsAndConditionsVersion
  latestTermsAndConditionsVersionAccepted
  acceptedTimestamp
}`);
export const ReadUserUiPreferencesDocument = new TypedDocumentString(`
    query ReadUserUiPreferences {
  __typename
  readUserUiPreferences {
    __typename
    uiPreferences
    objectVersion
  }
}
    `);
export const ReadRoleDocument = new TypedDocumentString(`
    query ReadRole($userRoleId: String!) {
  __typename
  readUserRole(userRoleId: $userRoleId) {
    __typename
    ...UserRole
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment UserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  users {
    __typename
    itemCount
    items {
      __typename
      ...BaseUser
    }
  }
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}`);
export const ReadUsersForRoleDocument = new TypedDocumentString(`
    query ReadUsersForRole($userRoleId: String!, $pagination: PaginationInput) {
  __typename
  readUsersForUserRole(userRoleId: $userRoleId, pagination: $pagination) {
    __typename
    items {
      __typename
      ...User
    }
    itemCount
    pages
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}
fragment BaseUser on UserResponseType {
  __typename
  userId
  firstName
  lastName
  companyName
  email
  creationTimestamp
  updateTimestamp
  objectVersion
  source
  groupId
  jobTitle
  isSystemUser
}
fragment User on UserResponseType {
  __typename
  ...BaseUser
  userRoles {
    __typename
    items {
      __typename
      ...OwnUserRole
    }
    pages
    itemCount
  }
}`);
export const ReadTenantsForUserDocument = new TypedDocumentString(`
    query ReadTenantsForUser {
  __typename
  readAdditionalTenantsForUser {
    __typename
    items {
      __typename
      ...BaseTenant
    }
  }
}
    fragment OwnerUserInfo on OwnerUserResponseType {
  __typename
  firstName
  lastName
  email
}
fragment BaseTenant on TenantResponseType {
  __typename
  tenantId
  companyName
  owner {
    __typename
    ...OwnerUserInfo
  }
}`);
export const ReadUserRoleLinksForUserDocument = new TypedDocumentString(`
    query ReadUserRoleLinksForUser($userId: String!) {
  __typename
  readUserRoleUserLinksForUser(userId: $userId) {
    __typename
    items {
      __typename
      ...UserRoleLink
    }
    itemCount
    pages
  }
}
    fragment UserRoleLink on UserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const ReadUserRoleLinksForRoleDocument = new TypedDocumentString(`
    query ReadUserRoleLinksForRole($userRoleId: String!) {
  __typename
  readUserRoleUserLinksForUserRole(userRoleId: $userRoleId) {
    __typename
    items {
      __typename
      ...UserRoleLink
    }
    itemCount
    pages
  }
}
    fragment UserRoleLink on UserRoleUserLinkResponseType {
  __typename
  expirationTimestamp
  userId
  userRoleId
  objectVersion
}`);
export const ReadPoliciesForUserDocument = new TypedDocumentString(`
    query ReadPoliciesForUser($userId: String!) {
  __typename
  readUserRolesForUser(userId: $userId) {
    __typename
    items {
      __typename
      policies {
        __typename
        ...Policy
      }
    }
  }
}
    fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}`);
export const ReadPoliciesForOwnUserDocument = new TypedDocumentString(`
    query ReadPoliciesForOwnUser {
  __typename
  readUserRolesForOwnUser {
    __typename
    items {
      __typename
      ...OwnUserRole
    }
    itemCount
    pages
  }
}
    fragment IdentUserInfo on LightUserResponseType {
  __typename
  firstName
  lastName
  userId
  email
  source
  isSystemUser
}
fragment Policy on PolicyType {
  __typename
  name
  action
  resource
  description
}
fragment OwnUserRole on UserRoleResponseType {
  __typename
  name
  isSystemRole
  creationTimestamp
  updateTimestamp
  objectVersion
  userRoleId
  description
  ssoGroupMapping
  policies {
    __typename
    ...Policy
  }
  creationUser {
    __typename
    ...IdentUserInfo
  }
  groupId
}`);
export const ReadGroupedIdentitiesCountDocument = new TypedDocumentString(`
    query ReadGroupedIdentitiesCount($groupId: String!) {
  __typename
  readAllUsers(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllUserRoles(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadUngroupedIdentitiesCountDocument = new TypedDocumentString(`
    query ReadUngroupedIdentitiesCount {
  __typename
  readAllUsers(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllUserRoles(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadGroupedIdentityCountsDocument = new TypedDocumentString(`
    query ReadGroupedIdentityCounts($groupIds: [String!]!) {
  __typename
  readGroupedIdentityCounts(groupIds: $groupIds) {
    __typename
    groupId
    users
    userRoles
  }
}
    `);

const injectedRtkApi = baseIdentApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateUser: build.mutation<Types.CreateUserMutation, Types.CreateUserMutationVariables>({
      query: (variables) => ({ document: CreateUserDocument as unknown as string, variables })
    }),
    LinkRoleToUser: build.mutation<Types.LinkRoleToUserMutation, Types.LinkRoleToUserMutationVariables>({
      query: (variables) => ({ document: LinkRoleToUserDocument as unknown as string, variables })
    }),
    CreateUserRole: build.mutation<Types.CreateUserRoleMutation, Types.CreateUserRoleMutationVariables>({
      query: (variables) => ({ document: CreateUserRoleDocument as unknown as string, variables })
    }),
    UpdateUser: build.mutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>({
      query: (variables) => ({ document: UpdateUserDocument as unknown as string, variables })
    }),
    DeleteRole: build.mutation<Types.DeleteRoleMutation, Types.DeleteRoleMutationVariables>({
      query: (variables) => ({ document: DeleteRoleDocument as unknown as string, variables })
    }),
    RemoveRoleFromUser: build.mutation<Types.RemoveRoleFromUserMutation, Types.RemoveRoleFromUserMutationVariables>({
      query: (variables) => ({ document: RemoveRoleFromUserDocument as unknown as string, variables })
    }),
    DeleteUser: build.mutation<Types.DeleteUserMutation, Types.DeleteUserMutationVariables>({
      query: (variables) => ({ document: DeleteUserDocument as unknown as string, variables })
    }),
    UpdateUserRole: build.mutation<Types.UpdateUserRoleMutation, Types.UpdateUserRoleMutationVariables>({
      query: (variables) => ({ document: UpdateUserRoleDocument as unknown as string, variables })
    }),
    SelectTenant: build.mutation<Types.SelectTenantMutation, Types.SelectTenantMutationVariables>({
      query: (variables) => ({ document: SelectTenantDocument as unknown as string, variables })
    }),
    UpdateTenant: build.mutation<Types.UpdateTenantMutation, Types.UpdateTenantMutationVariables>({
      query: (variables) => ({ document: UpdateTenantDocument as unknown as string, variables })
    }),
    UpdateUserRoleLink: build.mutation<Types.UpdateUserRoleLinkMutation, Types.UpdateUserRoleLinkMutationVariables>({
      query: (variables) => ({ document: UpdateUserRoleLinkDocument as unknown as string, variables })
    }),
    GenerateTwoFactorAuthToken: build.mutation<Types.GenerateTwoFactorAuthTokenMutation, Types.GenerateTwoFactorAuthTokenMutationVariables>({
      query: (variables) => ({ document: GenerateTwoFactorAuthTokenDocument as unknown as string, variables })
    }),
    AuthenticateTwoFactorAuthToken: build.mutation<Types.AuthenticateTwoFactorAuthTokenMutation, Types.AuthenticateTwoFactorAuthTokenMutationVariables>({
      query: (variables) => ({ document: AuthenticateTwoFactorAuthTokenDocument as unknown as string, variables })
    }),
    VerifyTotpTwoFactorAuth: build.mutation<Types.VerifyTotpTwoFactorAuthMutation, Types.VerifyTotpTwoFactorAuthMutationVariables>({
      query: (variables) => ({ document: VerifyTotpTwoFactorAuthDocument as unknown as string, variables })
    }),
    AcceptTermsAndConditions: build.mutation<Types.AcceptTermsAndConditionsMutation, Types.AcceptTermsAndConditionsMutationVariables | void>({
      query: (variables) => ({ document: AcceptTermsAndConditionsDocument as unknown as string, variables })
    }),
    UpdateUserUiPreferences: build.mutation<Types.UpdateUserUiPreferencesMutation, Types.UpdateUserUiPreferencesMutationVariables | void>({
      query: (variables) => ({ document: UpdateUserUiPreferencesDocument as unknown as string, variables })
    }),
    ReadTenant: build.query<Types.ReadTenantQuery, Types.ReadTenantQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantDocument as unknown as string, variables })
    }),
    ReadAllUsers: build.query<Types.ReadAllUsersQuery, Types.ReadAllUsersQueryVariables | void>({
      query: (variables) => ({ document: ReadAllUsersDocument as unknown as string, variables })
    }),
    ReadAllUsersBase: build.query<Types.ReadAllUsersBaseQuery, Types.ReadAllUsersBaseQueryVariables | void>({
      query: (variables) => ({ document: ReadAllUsersBaseDocument as unknown as string, variables })
    }),
    ReadUsersCount: build.query<Types.ReadUsersCountQuery, Types.ReadUsersCountQueryVariables | void>({
      query: (variables) => ({ document: ReadUsersCountDocument as unknown as string, variables })
    }),
    ReadAllRoles: build.query<Types.ReadAllRolesQuery, Types.ReadAllRolesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllRolesDocument as unknown as string, variables })
    }),
    ReadUser: build.query<Types.ReadUserQuery, Types.ReadUserQueryVariables>({
      query: (variables) => ({ document: ReadUserDocument as unknown as string, variables })
    }),
    ReadTermsAndConditionsAcceptance: build.query<Types.ReadTermsAndConditionsAcceptanceQuery, Types.ReadTermsAndConditionsAcceptanceQueryVariables | void>({
      query: (variables) => ({ document: ReadTermsAndConditionsAcceptanceDocument as unknown as string, variables })
    }),
    ReadUserUiPreferences: build.query<Types.ReadUserUiPreferencesQuery, Types.ReadUserUiPreferencesQueryVariables | void>({
      query: (variables) => ({ document: ReadUserUiPreferencesDocument as unknown as string, variables })
    }),
    ReadRole: build.query<Types.ReadRoleQuery, Types.ReadRoleQueryVariables>({
      query: (variables) => ({ document: ReadRoleDocument as unknown as string, variables })
    }),
    ReadUsersForRole: build.query<Types.ReadUsersForRoleQuery, Types.ReadUsersForRoleQueryVariables>({
      query: (variables) => ({ document: ReadUsersForRoleDocument as unknown as string, variables })
    }),
    ReadTenantsForUser: build.query<Types.ReadTenantsForUserQuery, Types.ReadTenantsForUserQueryVariables | void>({
      query: (variables) => ({ document: ReadTenantsForUserDocument as unknown as string, variables })
    }),
    ReadUserRoleLinksForUser: build.query<Types.ReadUserRoleLinksForUserQuery, Types.ReadUserRoleLinksForUserQueryVariables>({
      query: (variables) => ({ document: ReadUserRoleLinksForUserDocument as unknown as string, variables })
    }),
    ReadUserRoleLinksForRole: build.query<Types.ReadUserRoleLinksForRoleQuery, Types.ReadUserRoleLinksForRoleQueryVariables>({
      query: (variables) => ({ document: ReadUserRoleLinksForRoleDocument as unknown as string, variables })
    }),
    ReadPoliciesForUser: build.query<Types.ReadPoliciesForUserQuery, Types.ReadPoliciesForUserQueryVariables>({
      query: (variables) => ({ document: ReadPoliciesForUserDocument as unknown as string, variables })
    }),
    ReadPoliciesForOwnUser: build.query<Types.ReadPoliciesForOwnUserQuery, Types.ReadPoliciesForOwnUserQueryVariables | void>({
      query: (variables) => ({ document: ReadPoliciesForOwnUserDocument as unknown as string, variables })
    }),
    ReadGroupedIdentitiesCount: build.query<Types.ReadGroupedIdentitiesCountQuery, Types.ReadGroupedIdentitiesCountQueryVariables>({
      query: (variables) => ({ document: ReadGroupedIdentitiesCountDocument as unknown as string, variables })
    }),
    ReadUngroupedIdentitiesCount: build.query<Types.ReadUngroupedIdentitiesCountQuery, Types.ReadUngroupedIdentitiesCountQueryVariables | void>({
      query: (variables) => ({ document: ReadUngroupedIdentitiesCountDocument as unknown as string, variables })
    }),
    ReadGroupedIdentityCounts: build.query<Types.ReadGroupedIdentityCountsQuery, Types.ReadGroupedIdentityCountsQueryVariables>({
      query: (variables) => ({ document: ReadGroupedIdentityCountsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateUserMutation, useLinkRoleToUserMutation, useCreateUserRoleMutation, useUpdateUserMutation, useDeleteRoleMutation, useRemoveRoleFromUserMutation, useDeleteUserMutation, useUpdateUserRoleMutation, useSelectTenantMutation, useUpdateTenantMutation, useUpdateUserRoleLinkMutation, useGenerateTwoFactorAuthTokenMutation, useAuthenticateTwoFactorAuthTokenMutation, useVerifyTotpTwoFactorAuthMutation, useAcceptTermsAndConditionsMutation, useUpdateUserUiPreferencesMutation, useReadTenantQuery, useLazyReadTenantQuery, useReadAllUsersQuery, useLazyReadAllUsersQuery, useReadAllUsersBaseQuery, useLazyReadAllUsersBaseQuery, useReadUsersCountQuery, useLazyReadUsersCountQuery, useReadAllRolesQuery, useLazyReadAllRolesQuery, useReadUserQuery, useLazyReadUserQuery, useReadTermsAndConditionsAcceptanceQuery, useLazyReadTermsAndConditionsAcceptanceQuery, useReadUserUiPreferencesQuery, useLazyReadUserUiPreferencesQuery, useReadRoleQuery, useLazyReadRoleQuery, useReadUsersForRoleQuery, useLazyReadUsersForRoleQuery, useReadTenantsForUserQuery, useLazyReadTenantsForUserQuery, useReadUserRoleLinksForUserQuery, useLazyReadUserRoleLinksForUserQuery, useReadUserRoleLinksForRoleQuery, useLazyReadUserRoleLinksForRoleQuery, useReadPoliciesForUserQuery, useLazyReadPoliciesForUserQuery, useReadPoliciesForOwnUserQuery, useLazyReadPoliciesForOwnUserQuery, useReadGroupedIdentitiesCountQuery, useLazyReadGroupedIdentitiesCountQuery, useReadUngroupedIdentitiesCountQuery, useLazyReadUngroupedIdentitiesCountQuery, useReadGroupedIdentityCountsQuery, useLazyReadGroupedIdentityCountsQuery } = injectedRtkApi;

